import { render, staticRenderFns } from "./SelectCom.vue?vue&type=template&id=3b8b8144&scoped=true&"
import script from "./SelectCom.vue?vue&type=script&lang=js&"
export * from "./SelectCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b8144",
  null
  
)

export default component.exports